<template>
  <div class="mt-5">
    <div class="hr-bar">
      <div class="hr-bar-right hr-field">
        <label>Sort by</label>
        <select class="hr-select" v-model="sortOrder" style="min-width: 200px">
          <option v-for="o in sortOptions" :key="o.value" :value="o.value">{{
            o.text
          }}</option>
        </select>
      </div>
    </div>
    <!-- Skeleton loaders -->
    <b-col
      v-if="tasks.length === 0"
      md="12"
      xl="12"
      lg="12"
      class="px-0 mb-3 mt-5"
    >
      <b-card
        v-for="(item, index) in 3"
        :key="index"
        class="mb-2 border-primary-lighter border-radius-sm"
      >
        <b-card-body class="d-flex align-items-center py-4">
          <b-col md="6">
            <b-skeleton width="40%"></b-skeleton>
            <b-skeleton width="60%"></b-skeleton>
          </b-col>
          <b-col md="3" class="d-flex align-items-center flex-column">
            <b-skeleton width="50%"></b-skeleton>
          </b-col>
          <b-col class="d-flex justify-content-center">
            <b-skeleton width="50%"></b-skeleton>
          </b-col>
          <b-col class="d-flex justify-content-end pr-0">
            <b-skeleton type="avatar" size="4.4rem"></b-skeleton>
          </b-col>
        </b-card-body>
      </b-card>
    </b-col>
    <!-- End loaders -->
    <!-- <b-col
      md="12"
      xl="12"
      lg="12"
      class="d-flex mb-0 mt-5 headers-wrapper-column"
    >
      <b-col md="8" class="px-0 ">
        <p class="primary--text font-family-medium position-relative ml-3">
          Task
        </p>
      </b-col>
      <b-col md="4" class="d-flex align-items-start justify-content-end">
        <p class="primary--text font-family-medium position-relative">
          Created At
        </p>
      </b-col>
    </b-col> -->
    <b-toast
      id="save-indicator"
      solid
      ref="saveIndicator"
      :no-close-button="true"
      :no-auto-hide="true"
      :no-fade="true"
      toaster="b-toaster-top-center"
      :visible="isSaveIndicatorVisible"
    >
      <div id="loading-icon-wrapper" v-show="indicatorsVisible.saving">
        <img src="@/assets/icons/save-loading.svg" />
      </div>
      <div id="saved-icon-wrapper" v-show="indicatorsVisible.saved">
        <img src="@/assets/icons/save-tick.png" />
      </div>
      <div id="save-indicator-text">
        {{ indicatorsVisible.saving ? "Saving..." : "Saved" }}
      </div>
    </b-toast>
    <b-toast
      id="save-error-indicator"
      solid
      :no-close-button="true"
      :no-auto-hide="true"
      :no-fade="true"
      toaster="b-toaster-top-center"
      v-model="indicatorsVisible.error"
    >
      <div id="error-icon-wrapper">
        <img src="@/assets/icons/save-error.svg" />
      </div>
      <div id="save-indicator-text-error">
        {{
          correctionError === "month"
            ? " Only current month duration can be edited"
            : " Error! Something went wrong"
        }}
      </div>
      <div id="save-indicator-close-icon">
        <img
          src="@/assets/icons/close_sidebar.svg"
          @click="closeErrorIndicator"
        />
      </div>
    </b-toast>
    <b-col md="12" xl="12" lg="12" class="px-0" v-if="tasks.length">
      <b-card
        class=" pr-2 pt-2 pl-2 pb-0 border-primary-lighter bg--light"
        no-body
      >
        <b-card
          @mouseenter="showCardHover(item.id)"
          @mouseleave="undoCardHover(item.id)"
          no-body
          @click="navigateToTasks(item.id)"
          v-for="(item, index) in tasks"
          :key="index"
          class="mb-2 border-primary-lighter border-radius-sm"
        >
          <b-card-body class="d-flex flex-wrap align-items-center">
            <b-col md="8">
              <h6 class="font-sm primary--text font-family-medium">
                {{
                  item.title.length > 50
                    ? `${item.title.substring(0, 50)}...`
                    : item.title
                }}
              </h6>
            </b-col>
            <!-- <b-col md="2" class="d-flex align-items-center">
              <h6 class="font-sm secondary--text font-weight-normal mt-3">
                {{ humanizeTime(item.startAt) }}
              </h6>
            </b-col> -->
            <b-col md="4" class="d-flex align-items-center justify-content-end">
              <h6 class="font-sm secondary--text font-weight-normal mt-3">
                Created At: {{ humanizeTime(item.created) }}
              </h6>
            </b-col>
            <!-- <b-col md="2" class="d-flex justify-content-center">
              <input
                contenteditable
                class="font-sm secondary--text font-weight-normal mt-3 edit-duration"
                v-on:change="updateDuration($event, item)"
                v-bind:value="getDurationInHHMM(item.duration)"
                data="item"
              />
            </b-col> -->
            <b-col class="p-0">
              <b-card
                class=" pr-2 pt-2 pl-2 pb-0 border-primary-lighter bg--light"
                no-body
              >
                <b-card
                  no-body
                  class="mb-2 border-primary-lighter border-radius-sm"
                >
                  <b-card-body class="d-flex align-items-center">
                    <b-col md="2" class="d-flex justify-content-center">
                      <h6 class="font-sm primary--text font-family-medium">
                        Timers
                      </h6>
                    </b-col>
                    <b-col
                      md="4"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <h6
                        class="font-sm secondary--text font-weight-normal mt-3"
                      >
                        Start Time
                      </h6>
                    </b-col>
                    <b-col
                      md="4"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <h6
                        class="font-sm secondary--text font-weight-normal mt-3"
                      >
                        Stop Time
                      </h6>
                    </b-col>
                    <b-col md="2" class="d-flex justify-content-center">
                      <h6
                        class="font-sm secondary--text font-weight-normal mt-3"
                      >
                        Duration (hh:mm)
                      </h6>
                    </b-col>
                  </b-card-body>
                </b-card>
                <b-card
                  no-body
                  v-for="(track, trackIndex) in item.trackers"
                  :key="trackIndex"
                  class="mb-2 border-primary-lighter border-radius-sm"
                >
                  <b-card-body class="d-flex align-items-center">
                    <b-col md="2" class="d-flex justify-content-center">
                      <h6 class="font-sm primary--text font-family-medium">
                        {{ trackIndex + 1 }}
                      </h6>
                    </b-col>
                    <b-col
                      md="4"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <h6
                        class="font-sm secondary--text font-weight-normal mt-3"
                      >
                        {{ humanizeTime(track.startAt) }}
                      </h6>
                    </b-col>
                    <b-col
                      md="4"
                      class="d-flex align-items-center justify-content-center"
                    >
                      <h6
                        class="font-sm secondary--text font-weight-normal mt-3"
                      >
                        {{
                          humanizeTime(
                            stoptime[track.id]
                              ? stoptime[track.id]
                              : track.stopAt
                          )
                        }}
                      </h6>
                    </b-col>
                    <b-col
                      md="2"
                      class="d-flex flex-column align-items-center justify-content-center"
                      @click.stop
                    >
                      <h6
                        class="font-sm secondary--text font-weight-normal mt-3"
                      >
                        {{ getDurationInHHMM(track.duration, "hour") }}:{{
                          getDurationInHHMM(track.duration)
                        }}
                      </h6>
                      <button
                        v-if="correctionWindowOpenFor(track.startAt)"
                        class="hr-btn hr-btn-sm mt-1"
                        @click="openCorrection(track, item)"
                      >
                        <b-icon icon="pencil" font-scale="0.75" /> Correct
                      </button>
                      <span
                        v-else
                        class="hr-badge b-slate mt-1"
                        v-b-tooltip.hover
                        :title="
                          isAdmin
                            ? 'This period is fully locked past the Wednesday deadline.'
                            : 'This period is locked. Only an Admin can correct it now.'
                        "
                        >Locked</span
                      >
                    </b-col>
                  </b-card-body>
                </b-card>
              </b-card>
            </b-col>
          </b-card-body>
        </b-card>
      </b-card>
    </b-col>
    <div
      class="no-assigned-msg pr-5 pt-5 pb-5 pl-2 d-flex flex-column justify-content-center align-items-center"
      v-if="tasks.length === 0"
    >
      <h4 class="font-md primary--text font-family-medium">
        No tasks found.
      </h4>
    </div>

    <!-- Correction Modal -->
    <div class="hr-overlay" v-if="editing" @click="closeModal">
      <div class="hr-modal" @click.stop>
        <div class="hr-modal-head">
          <span
            style="
              width: 34px; height: 34px; border-radius: 9px;
              background: #fce7ef; display: flex; align-items: center;
              justify-content: center;
            "
          >
            <b-icon icon="stopwatch" font-scale="1" style="color: #e11d48" />
          </span>
          <div>
            <div style="font-weight: 700">Correct timer</div>
            <div style="font-size: 12px; color: #94a3b8">
              {{ editing.task }}
            </div>
          </div>
          <button
            class="hr-btn hr-btn-sm"
            style="margin-left: auto; border: 0"
            @click="closeModal"
          >
            <b-icon icon="x" font-scale="1.1" />
          </button>
        </div>

        <div class="hr-modal-body">
          <div style="display: flex; gap: 22px; margin-bottom: 18px">
            <div>
              <div style="font-size: 11px; color: #94a3b8; font-weight: 600">
                RECORDED
              </div>
              <div class="num" style="margin-top: 8px; font-weight: 600">
                {{ fmtH(editing.minutes) }}
              </div>
            </div>
          </div>

          <div
            style="font-size: 12px; font-weight: 600; color: #64748b; margin-bottom: 8px"
          >
            New duration
          </div>
          <div style="display: flex; align-items: center; gap: 14px">
            <div class="hr-stepper">
              <button @click="stepModal(-5)">
                <b-icon icon="dash" font-scale="1.1" />
              </button>
              <div class="val">
                <input
                  type="text"
                  inputmode="numeric"
                  placeholder="h:mm"
                  class="val-input"
                  :value="fmtH(modalVal)"
                  @change="onDurationInput"
                /><span class="unit">h:mm</span>
              </div>
              <button @click="stepModal(5)">
                <b-icon icon="plus" font-scale="1.1" />
              </button>
            </div>
            <span
              v-if="modalDelta !== 0"
              :class="['hr-badge', modalDelta > 0 ? 'b-teal' : 'b-amber']"
              >{{ modalDelta > 0 ? "+" : "" }}{{ modalDelta }} min</span
            >
          </div>

          <div
            style="font-size: 12px; font-weight: 600; color: #64748b; margin: 18px 0 8px"
          >
            Reason for correction <span style="color: #e11d48">*</span>
          </div>
          <select class="hr-select" style="width: 100%" v-model="modalReason">
            <option value="">Select a reason…</option>
            <option v-for="r in reasons" :key="r">{{ r }}</option>
          </select>

          <div class="hr-confirm">
            <b-icon
              icon="exclamation-triangle"
              font-scale="0.9"
              style="flex-shrink: 0; margin-top: 1px"
            />
            <span>
              You're changing this timer from
              <b>{{ fmtH(editing.minutes) }}</b> to
              <b>{{ fmtH(modalVal) }}</b>. This affects billing. Are you sure?
            </span>
          </div>
        </div>

        <div class="hr-modal-foot">
          <button class="hr-btn" @click="closeModal">Cancel</button>
          <span v-b-tooltip.hover :title="confirmDisabledReason">
            <button
              class="hr-btn hr-btn-danger"
              :disabled="!modalReason || !modalDeltaValid"
              @click="saveCorrection"
            >
              <b-icon icon="check" font-scale="0.9" /> Confirm correction
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { patchTracker } from "@/apis/common";
import { getTimeTrackers } from "@/apis/customers";
import {
  TIMER_CORRECTION_REASONS,
  ADMIN_INVOICE_CORRECTION_REASON,
  MIN_CORRECTION_MINUTES
} from "@/utils/constants/index";
import { snapCorrectionMinutes } from "@/utils/utils";

const SORT_OPTIONS = [
  { value: "newest", text: "Newest completed first" },
  { value: "oldest", text: "Oldest completed first" }
];

export default {
  name: "TaskListReport",
  props: {
    customerId: String,
    categories: String,
    assignedTo: String,
    minDate: String,
    maxDate: String
  },
  computed: {
    stoptime: {
      get: function() {
        return this.stopAt;
      },
      set: function(item) {
        this.stopAt[item.id] = moment
          .parseZone(item.startAt)
          .add(item.duration, "seconds");
      }
    },
    isSaveIndicatorVisible() {
      let ret = this.indicatorsVisible.saving || this.indicatorsVisible.saved;
      return ret;
    },
    isAdmin() {
      return this.$store.state.authModule.role === "admin";
    },
    reasons() {
      return this.isAdmin
        ? [...TIMER_CORRECTION_REASONS, ADMIN_INVOICE_CORRECTION_REASON]
        : TIMER_CORRECTION_REASONS;
    },
    modalDelta() {
      return this.editing ? this.modalVal - this.editing.minutes : 0;
    },
    // modalVal is always kept on the 5-minute grid (see onDurationInput/
    // stepModal), so the only remaining invalid state is "nothing changed".
    modalDeltaValid() {
      return this.modalDelta !== 0;
    },
    confirmDisabledReason() {
      if (!this.modalReason) return "Select a reason for this correction first";
      if (!this.modalDeltaValid) return "Choose a new duration before confirming";
      return "";
    }
  },
  data() {
    return {
      expandHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      tasks: [],
      // trackers: [],
      // trackersKey: "0",
      stopAt: {},
      indicatorsVisible: {
        saving: false,
        saved: false,
        error: false
      },
      correctionError: "",
      editing: null,
      modalVal: 0,
      modalReason: "",
      sortOrder: "newest",
      sortOptions: SORT_OPTIONS
    };
  },
  created() {
    this.stoptime = [];
    this.loadTasks();
  },
  watch: {
    sortOrder() {
      this.loadTasks();
    }
  },
  mounted() {
    // this.trackersKey = "1";
    // this.$forceUpdate();
  },
  methods: {
    loadTasks() {
      const params = {
        limit: 50,
        completed_gte: this.minDate,
        completed_lte: this.maxDate,
        assigned_to: this.assignedTo
          ? this.assignedTo
          : this.$store.state.authModule.role === "admin"
          ? ""
          : this.$store.state.authModule.profileUserId,
        categories: this.categories,
        sort: this.sortOrder
      };
      getTimeTrackers(this.customerId, params)
        .then(res => {
          this.tasks = res.data.results;
        })
        .catch(err => {
          console.log(err);
        });
    },
    trimDescription(description) {
      let des = description.replace(/<(.|\n)*?>/g, " ").trim();
      if (des.length > 75) {
        return `${des.substring(0, 72)}...`;
      } else if (des.length > 0) {
        return des;
      } else {
        return "...";
      }
    },
    humanizeTime(input) {
      return moment(input)
        .local()
        .format("MM/DD/YYYY hh:mm a");
    },
    getDurationInHHMM(seconds, type) {
      let duration = moment.duration(seconds, "seconds").format("hh:mm");

      if (duration.length) {
        let dividerPos = duration.search(":");
        if (type === "hour" && dividerPos > 0) {
          let hours = duration.substring(0, dividerPos);
          return hours;
        } else if (type === "hour") {
          return "00";
        } else if (dividerPos > 0) {
          let mins = duration.substring(dividerPos + 1);
          return mins;
        } else {
          return duration;
        }
      }
      return null;
    },
    navigateToTasks(id) {
      this.$router.push({
        name: "ViewTask",
        params: {
          id
        }
      });
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
    },
    // EAs can correct a timer only until the following Monday 12:00 PM UTC
    // (relative to the week the tracker ran in); admins get until Wednesday.
    correctionWindowOpenFor(startAt) {
      if (!startAt) return false;
      const deadlineOffsetDays = this.isAdmin ? 9 : 7;
      const weekMonday = moment.utc(startAt).startOf("isoWeek");
      const deadline = weekMonday
        .add(deadlineOffsetDays, "days")
        .add(12, "hours");
      return moment.utc().isSameOrBefore(deadline);
    },
    openCorrection(track, item) {
      this.editing = {
        task: item.title,
        taskId: item.id,
        trackerId: track.id,
        startAt: track.startAt,
        minutes: Math.round(track.duration / 60)
      };
      this.modalVal = this.editing.minutes;
      this.modalReason = "";
    },
    // "1:30" / "90" / "" -> total minutes. Anything unparseable falls back
    // to the current value instead of silently zeroing the field out.
    parseHHMM(str) {
      const parts = String(str).trim().split(":");
      if (parts.length === 2) {
        const h = parseInt(parts[0], 10) || 0;
        const m = parseInt(parts[1], 10) || 0;
        return h * 60 + m;
      }
      const n = parseInt(str, 10);
      return isNaN(n) ? this.modalVal : n;
    },
    // The corrected total must land on a multiple of 5 minutes (the backend
    // enforces this) - snap on typed input, and on every +/- stepper click
    // too, so a non-multiple recording (e.g. 11m) still lands clean (15,
    // not 16) instead of just drifting by the raw step size.
    onDurationInput(e) {
      this.modalVal = snapCorrectionMinutes(
        this.parseHHMM(e.target.value),
        MIN_CORRECTION_MINUTES
      );
    },
    // Minutes -> "H:MM" (matches DailyView/TimerCorrections' identical fmtH).
    fmtH(m) {
      return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")}`;
    },
    stepModal(delta) {
      this.modalVal = snapCorrectionMinutes(
        this.modalVal + delta,
        MIN_CORRECTION_MINUTES
      );
    },
    closeModal() {
      this.editing = null;
    },
    saveCorrection() {
      if (!this.editing || !this.modalDeltaValid) return;
      this.showSaveIndicator();
      const { taskId, trackerId } = this.editing;
      const stopAt = moment
        .utc(this.editing.startAt)
        .add(this.modalVal, "minutes")
        .format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]");
      const data = { action: "correction", stopAt, reason: this.modalReason };
      patchTracker(taskId, trackerId, data)
        .then(() => {
          const item = this.tasks.find(t => t.id === taskId);
          const track = item && item.trackers.find(tr => tr.id === trackerId);
          if (track) {
            track.duration = this.modalVal * 60;
            this.stoptime = track;
          }
          this.showSaveIndicatorSaved();
          this.closeModal();
        })
        .catch(err => {
          console.log(err);
          this.showSaveIndicatorError();
        });
    },
    showSaveIndicator() {
      this.indicatorsVisible.error = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.saving = true;
    },
    showSaveIndicatorSaved() {
      this.indicatorsVisible.error = false;
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = true;
      window.setTimeout(() => {
        this.indicatorsVisible.saved = false;
      }, 1500);
    },
    showSaveIndicatorError(error) {
      if (error === "month") {
        this.correctionError = error;
      }
      this.indicatorsVisible.saving = false;
      this.indicatorsVisible.saved = false;
      this.indicatorsVisible.error = true;
    },
    closeErrorIndicator() {
      this.indicatorsVisible.error = false;
      this.correctionError = "";
    }
  }
};
</script>

<style scoped lang="scss">
.table-header-3 {
  left: 2rem;
}
.categories-title {
  right: 1rem;
}
.more--text {
  left: 0.3rem;
  top: 2.2rem;
}
.card {
  cursor: pointer;
  .card-body {
    padding: 4.5px 0;
  }
}
.headers-wrapper-column {
  padding: 4.5px;
}
.p-0 {
  padding: 0 !important;
}
</style>
<style lang="scss">
$image-dimension: 25px;
$pink: #f35a63;
$dark-blue: #0a374b;

#save-indicator,
#save-error-indicator {
  border-radius: 999px;
  margin: auto;
  box-shadow: none;
  border: none;
  width: fit-content;
  div.toast-body {
    padding: 10px 5px;
    font-size: 16px;
    display: flex;
  }
}
#save-indicator:focus,
#save-error-indicator:focus {
  border: none;
  outline: none;
}

#save-indicator {
  width: 113px;
  div.toast-body {
    background: $dark-blue;
    border-radius: 999px;
    color: white;
    display: flex;
  }
  #loading-icon-wrapper {
    // flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
      animation: spin 1s linear infinite;
    }
  }
  #saved-icon-wrapper {
    // flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
      animation: growIn 1s;
    }
  }
  #save-indicator-text {
    flex: 2;
    text-align: center;
  }
}
#save-error-indicator {
  width: 300px;
  display: flex;
  border-radius: 30px;
  background: #f35a63;
  display: flex;
  > div.toast-body {
    flex: 1;
  }
  #save-indicator-text-error {
    color: white;
    text-align: center;
  }
  #error-icon-wrapper {
    background: #f35a63;
    border-bottom-left-radius: 999px;
    border-top-left-radius: 999px;
    color: white;
    flex: 1;
    > img {
      height: $image-dimension;
      width: $image-dimension;
      margin-top: 45%;
    }
  }
  #save-indicator-text {
    color: white;
    background: #f35a63;
    flex: 8;
    text-align: center;
  }
  #save-indicator-close-icon {
    background: #f35a63;
    color: white;
    width: $image-dimension;
    height: $image-dimension;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    > img {
      cursor: pointer;
      flex: 1;
      height: $image-dimension;
      width: $image-dimension;
      margin-top: 90%;
    }
    border-bottom-right-radius: 999px;
    border-top-right-radius: 999px;
  }
}
</style>
